import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const allocateRunnersService = {};

// List Allocate Runner
allocateRunnersService.listAllocateRunner = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat",
    "sun",
    "hub_id",
    // "hub",
    // "route",
    // "timeSlot",
  ];

  return fetchV2({
    url: `${env.API_MSP}/runner-schedules/schedule`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      keywords: params.keywords || "",
      expand: params.expand || "route,timeSlot",
      // fields: params.fields || defaultFields.join(","),
    },
  });
};

allocateRunnersService.listChangeScheduleByRunner = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/runner-schedule-changes`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
      sort: params.sort,
      "filter[record_status]": "O",
    },
  });
};

// createRunnerScheduleChanges
allocateRunnersService.createRunnerScheduleChanges = data => {
  return fetchV2({
    url: `${env.API_MSP}/runner-schedule-changes`,
    method: "post",
    data,
  });
};

// updateRunnerScheduleChanges
allocateRunnersService.updateRunnerScheduleChanges = data => {
  return fetchV2({
    url: `${env.API_MSP}/runner-schedule-changes/${data.id}`,
    method: "put",
    data,
  });
};

// deleteRunnerScheduleChanges
allocateRunnersService.deleteRunnerScheduleChanges = data => {
  return fetchV2({
    url: `${env.API_MSP}/runner-schedule-changes/${data.id}`,
    method: "delete",
  });
};

// clearRunnerScheduleChanges
allocateRunnersService.clearRunnerScheduleChanges = hubId => {
  return fetchV2({
    url: `${env.API_MSP}/runner-schedules/clear-data/${hubId}`,
    method: "delete",
  });
};

allocateRunnersService.changeRunnerType = () => {
  return fetchV2({
    url: `${env.API_MSP}/runner-schedule-changes/change-runner-type`,
    method: "get",
    params: {
      // ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      // keywords: params.keywords || "",
      // expand: params.expand || "",
      // fields: params.fields || defaultFields.join(","),
    },
  });
};

allocateRunnersService.listRunnerFree = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/list-runner-free`,
    method: "get",
    params: {
      date: params.date,
      timeslot_ids: params.timeslot_ids,
      type: params.type,
      hub_id: params.hub_id,
    },
  });
};

allocateRunnersService.listRunnerCurrent = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/list-runner-current`,
    method: "get",
    params: {
      date: params.date,
      timeslot_ids: params.timeslot_ids,
      type: params.type,
      hub_id: params.hub_id,
    },
  });
};

allocateRunnersService.getRunnerScheduleWeeksByHub = ({ hub_id }) => {
  return fetchV2({
    url: `${env.API_MSP}/runner-schedules/weeks-by-hub`,
    method: "get",
    params: {
      hub_id,
    },
  });
};

export default allocateRunnersService;
